import { VolumeHighIcon } from "assets";
import { MediaAsset } from "mediaModules/media/models";
import React from "react";
import {
  formatTime,
  handleEnterPress,
  TextEllipsis,
  transformMillisecToSec,
} from "component-library";

import "./TrackViewer.scss";
import { IExternalMedia } from "shared-types";
import { dataTestIds } from "data-testids";

export interface ITrackViewerProps {
  title: string;
  audioModel: MediaAsset | IExternalMedia;
  playback: (audio: MediaAsset | IExternalMedia) => void;
  titleMaxLines?: number;
}

export class TrackViewer extends React.Component<ITrackViewerProps> {
  public render() {
    const {
      audioModel: { isMediaObjectLoading },
    } = this.props;

    return (
      <div
        className="c-audio-viewer"
        data-testid={dataTestIds.profile["MainPage.MediaSection.Audio"]}
      >
        {isMediaObjectLoading
          ? this.renderLoadingMediaObject()
          : this.renderLoadedMediaObject()}
      </div>
    );
  }

  private renderLoadingMediaObject = () => {
    return (
      <div className="c-audio-viewer__preview c-audio-viewer__preview--loading">
        <div className="c-audio-viewer__thumbnail">
          <VolumeHighIcon width={48} height={48} />
        </div>
        <div className="c-audio-viewer__info">
          <div className="c-audio-viewer__title">{this.renderTitle()}</div>
          <div className="c-audio-viewer__duration">{""}</div>
        </div>
      </div>
    );
  };

  private renderLoadedMediaObject = () => {
    const {
      audioModel: { durationInMs = 0 },
      playback,
    } = this.props;
    const formattedAudioTime = formatTime(
      transformMillisecToSec(durationInMs),
      ":"
    );
    const action = playback.bind(this, this.props.audioModel);

    return (
      <div className="c-audio-viewer__preview">
        <div
          className="c-audio-viewer__thumbnail"
          onClick={action}
          tabIndex={0}
          onKeyPress={handleEnterPress(action)}
          role="button"
        >
          <VolumeHighIcon width={48} height={48} />
        </div>
        <div className="c-audio-viewer__info">
          <div className="c-audio-viewer__title">{this.renderTitle()}</div>
          <div className="c-audio-viewer__duration">{formattedAudioTime}</div>
        </div>
      </div>
    );
  };

  private renderTitle = () => {
    const { title, titleMaxLines } = this.props;

    return titleMaxLines ? (
      <TextEllipsis text={title} maxLine={titleMaxLines} basedOn="letters" />
    ) : (
      title
    );
  };
}

export default TrackViewer;
